import { Users, MessageCircle, ClipboardList, Clock, Award } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/content/site";

const ICONS = { Users, MessageCircle, ClipboardList, Clock, Award };

export const Leistungen = () => {
  return (
    <section id="leistungen" data-testid="services-section" className="scroll-mt-[var(--header-h)] section-pad">
      <div className="site-container">
        <Reveal>
          <p className="kicker">Was wir für Sie tun</p>
          <h2 className="mt-4 text-2xl font-semibold tracking-[-0.02em] text-foreground sm:text-3xl">
            Die richtigen Schweißer für Ihr Projekt.
          </h2>
          <p className="mt-4 max-w-[60ch] text-sm leading-relaxed text-muted-foreground sm:text-base">
            Wir vermitteln qualifizierte MIG/MAG-, WIG- und Elektroden-Schweißer passgenau zu Ihren Anforderungen –
            persönlich, ehrlich und zuverlässig.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:gap-6 md:grid-cols-2">
          {SERVICES.map((service, index) => {
            const Icon = ICONS[service.icon];
            return (
              <Reveal key={service.id} delay={index * 0.05}>
                <div 
                  data-testid={`service-tile-${service.id}`} 
                  className="tile group h-full overflow-hidden p-[var(--tile-pad)] transition-all duration-200 hover:border-[hsl(var(--brand-steelblue))]/30 hover:shadow-[var(--shadow-tile-hover)]"
                >
                  <div className="flex items-start justify-between">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[hsl(var(--brand-steelblue))]/10 text-[hsl(var(--brand-steelblue))] transition-colors group-hover:bg-[hsl(var(--brand-steelblue))]/15">
                      <Icon className="h-[18px] w-[18px]" />
                    </span>
                    <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60">{service.meta.split(',')[0]}</span>
                  </div>
                  <h3 className="mt-5 text-lg font-semibold tracking-[-0.01em] text-foreground sm:text-xl">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-[0.95rem] leading-relaxed text-muted-foreground">{service.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-9 text-sm text-muted-foreground">
            Brauchen Sie jemanden mit einer bestimmten Qualifikation?{" "}
            <a href="/#kontakt" data-testid="services-contact-link" className="font-medium text-[hsl(var(--brand-steelblue))] underline-offset-4 hover:underline">
              Sprechen Sie mit uns
            </a>{" "}
            – wir finden eine gute Lösung.
          </p>
        </Reveal>
      </div>
    </section>
  );
};